/**
 * Ζωντανή μορφοποίηση ποσού καθώς πληκτρολογεί ο χρήστης — τελεία ως
 * διαχωριστικό χιλιάδων, κόμμα ως δεκαδικό (ελληνική σύμβαση, π.χ. "5000" →
 * "5.000", "5000,42" → "5.000,42"). Σβήνει/ξαναβάζει τις τελείες σε κάθε
 * αλλαγή αντί να τις αφήνει όπως τις πληκτρολόγησε ο χρήστης, ώστε να μη
 * μπερδεύεται ποτέ ποια τελεία είναι δεκαδική.
 */
export function formatGroupedAmount(raw: string): string {
  // Δέξου και την τελεία ως δεκαδικό διαχωριστικό (όχι μόνο κόμμα) — αν δεν
  // υπάρχει ήδη κόμμα, η ΤΕΛΕΥΤΑΙΑ τελεία που πληκτρολόγησε ο χρήστης
  // μετατρέπεται σε κόμμα (οι προηγούμενες, αν υπάρχουν, είναι ήδη
  // διαχωριστικά χιλιάδων από προηγούμενο render και απλά αγνοούνται).
  let normalized = raw;
  if (!normalized.includes(',')) {
    const lastDot = normalized.lastIndexOf('.');
    if (lastDot !== -1) {
      normalized = normalized.slice(0, lastDot) + ',' + normalized.slice(lastDot + 1);
    }
  }
  let value = normalized.replace(/[^\d,]/g, '');
  const firstComma = value.indexOf(',');
  if (firstComma !== -1) {
    value = value.slice(0, firstComma + 1) + value.slice(firstComma + 1).replace(/,/g, '');
  }
  const [intPartRaw, decPart] = value.split(',');
  const intDigits = intPartRaw.replace(/\D/g, '');
  const grouped = intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return decPart !== undefined ? `${grouped},${decPart.slice(0, 2)}` : grouped;
}

/** Αντίστροφο του formatGroupedAmount — "5.000,42" → 5000.42. null αν κενό/μη έγκυρο. */
export function parseGroupedAmount(formatted: string): number | null {
  const trimmed = formatted.trim();
  if (!trimmed) return null;
  const normalized = trimmed.replace(/\./g, '').replace(',', '.');
  const v = Number(normalized);
  return Number.isFinite(v) ? v : null;
}

/**
 * Μετατρέπει έναν αριθμό (π.χ. από τη βάση/template, με JS δεκαδική τελεία)
 * στην ελληνική οπτική μορφή — 5000.5 → "5.000,5". ΔΙΑΦΟΡΕΤΙΚΟ από το
 * formatGroupedAmount, που ξαναμορφοποιεί ήδη-ελληνικό, ό,τι πληκτρολογεί ο
 * χρήστης· αυτό εδώ ξεκινάει από πραγματικό JS number.
 */
export function formatAmountForDisplay(n: number): string {
  if (!Number.isFinite(n)) return '';
  const [intPart, decPart] = n.toString().split('.');
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return decPart ? `${grouped},${decPart.slice(0, 2)}` : grouped;
}
